// @ts-check
import React from 'react';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/src/models/widget';
import { Image } from '@builder.io/react';

import ExploreMaterials from './explore-materials';
import ExploreMaterialsSecondary from './explore-materials-secondary';
const ExploreMaterialsWidget = ({ layout, materials, attributes }) =>
  layout === 'primary' ? (
    <ExploreMaterials
      materials={materials}
      BuilderImage={Image}
      isBuilder
      attributes={attributes}
    />
  ) : (
    <ExploreMaterialsSecondary
      materials={materials}
      BuilderImage={Image}
      isBuilder
      attributes={attributes}
    />
  );

ExploreMaterialsWidget.propTypes = { ...widgetPropType };

ExploreMaterialsWidget.defaultProps = { ...widgetDefaultProps };

export default ExploreMaterialsWidget;
